<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar class="print-scr"></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>

        <app-navbar></app-navbar>
        <div class="container mt-5">
          <div class="row" style="margin-right: 0px;margin-left: 0px;">
            <div class="col-sm-12 heading">
              <vs-breadcrumb
                align="left"
                :items="
              [
                {title: 'You are here : '},
                {
                  title: 'Dashboard',
                  url: '/#/dashboard/program-officer/todoList'
                },
                {
                  title: this.trainingTitle,
                  url: '/#/dashboard/program-officer/todoList'
                },
                {
                  title: 'Question List',
                  active: true
                }
              ]
                "
              ></vs-breadcrumb>
              <h3 class="text-secondary">Preview All Questions</h3>
            </div>
            <div class="col-sm-12 mb-3">
              <div class="card mb-2">
                <div class="card-body">
                  <b>Q1) What is the Capital of Pakistan</b>
                  <ul>
                    <li>a) Islamabad</li>
                    <li>b) Karachi</li>
                    <li>c) Lahore</li>
                    <li>d) Faislabad</li>
                  </ul>
                </div>
              </div>
              <div class="card mb-2">
                <div class="card-body">
                  <b>Q1) What is the Capital of Pakistan</b>
                  <ul>
                    <li>a) Islamabad</li>
                    <li>b) Karachi</li>
                    <li>c) Lahore</li>
                    <li>d) Faislabad</li>
                  </ul>
                </div>
              </div>
              <div class="card mb-2">
                <div class="card-body">
                  <b>Q1) What is the Capital of Pakistan</b>
                  <ul>
                    <li>a) Islamabad</li>
                    <li>b) Karachi</li>
                    <li>c) Lahore</li>
                    <li>d) Faislabad</li>
                  </ul>
                </div>
              </div>
              <div class="card mb-2">
                <div class="card-body">
                  <b>Q1) What is the Capital of Pakistan</b>
                  <ul>
                    <li>a) Islamabad</li>
                    <li>b) Karachi</li>
                    <li>c) Lahore</li>
                    <li>d) Faislabad</li>
                  </ul>
                </div>
              </div>
              <div class="card mb-2">
                <div class="card-body">
                  <b>Q1) What is the Capital of Pakistan</b>
                  <ul>
                    <li>a) Islamabad</li>
                    <li>b) Karachi</li>
                    <li>c) Lahore</li>
                    <li>d) Faislabad</li>
                  </ul>
                </div>
              </div>
              <div class="card mb-2">
                <div class="card-body">
                  <b>Q1) What is the Capital of Pakistan</b>
                  <ul>
                    <li>a) Islamabad</li>
                    <li>b) Karachi</li>
                    <li>c) Lahore</li>
                    <li>d) Faislabad</li>
                  </ul>
                </div>
              </div>
              <div class="card mb-2">
                <div class="card-body">
                  <b>Q1) What is the Capital of Pakistan</b>
                  <ul>
                    <li>a) Islamabad</li>
                    <li>b) Karachi</li>
                    <li>c) Lahore</li>
                    <li>d) Faislabad</li>
                  </ul>
                </div>
              </div>
              <div class="card mb-2">
                <div class="card-body">
                  <b>Q1) What is the Capital of Pakistan</b>
                  <ul>
                    <li>a) Islamabad</li>
                    <li>b) Karachi</li>
                    <li>c) Lahore</li>
                    <li>d) Faislabad</li>
                  </ul>
                </div>
              </div>
               <!-- <b-button class="print-scr"
                id="mybutton"
                @click="submitForm()"
                variant="primary"
                style="float:right;"
                size="sm"
                >Submit</b-button> -->
                <b-button
                variant="outline-success"
                class="float-right btn-sm print-scr mr-1"
                @click="printReport"
                >
                <i class="material-icons">print</i> Print
                </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Navbar from "./Navbar";
import Sidebar from "./subSidebar";

import axios from "axios";
export default {
  data: () => ({
    popupActivo4: false,
    trainingId: "",
    trainingTitle: "",
    startDate: "",
    endDate: "",
    no_of_question: "",
    allQuestionsArr: [],
    filteredQuestionsArr: [],
    selectedQuestionsArr: [],

    currentx: 1,
    currentx2: 1,
    radios1: "",
    value1: [0, 50],
    thematicArr: [],
    thematicSelected: "",
    thematicSettings: {
      maxItems: 5
    },
    previousTrainingArr: [],
    previoustrainingSelected: "",
    previoustrainingSettings: {
      maxItems: 3,
      plugins: ["remove_button"]
    },

    isSidebar: false,
    questionForm: true,
    filterForm: false,
    addPreassessmentForm: true,
    existPreassessmentForm: false,
    easyPercent: 0,
    easyPercentArr: [],
    mediumPercent: 0,
    mediumPercentArr: [],
    hardPercent: 0,
    hardPercentArr: [],
    thematicSelectedShowArr: [],
    thematicSelectedShow: "",
    thematicId: "",
    assessmentShowArr: []
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.trainingId = this.$route.query.trainingId;
    this.currentTraining();
    this.getPrevious();
    this.allQuestions();
    this.isExistPreAssessment();
    this.showAssessment();
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 2000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 2000,
        variant: "danger",
        solid: true
      });
    },
    // this will reset form elements
    resetFormElements: function resetFormElements() {
      this.thematicSelected = "";
      this.radios1 = "";
      this.previoustrainingSelected = "";
      this.allQuestions();
    },
    // this will check if pre assessment already created or not
    isExistPreAssessment: function isExistPreAssessment() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/assessment/" +
            this.trainingId +
            "/check/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success != "" && response.data.success != null) {
            this.addPreassessmentForm = false;
            this.existPreassessmentForm = true;
          } else {
            this.addPreassessmentForm = true;
            this.existPreassessmentForm = false;
          }
        });
    },
    filterQuestions() {
      if (this.radios1 != "" || this.previoustrainingSelected != "") {
        this.allQuestionsArr = [];
        this.questionForm = false;
        this.filterForm = true;
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH +
              "/admin/current-training/filter/get",
            {
              thematic: this.thematicId,
              level: this.radios1,
              priviousTraining: this.previoustrainingSelected
            }
          )
          .then(response => {
            this.closeLoading();
            this.allQuestionsArr = response.data;
          });
      }
    },
    // this will show current training of a program officer
    currentTraining: function currentTraining() {
      let userId = JSON.parse(localStorage.getItem("currentUser"));
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/current-training/" +
            this.trainingId +
            "/" +
            userId.id +
            "/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.trainingTitle = response.data.title;
          this.startDate = response.data.startdate;
          this.endDate = response.data.enddate;
          this.thematicId = response.data.thematic_id;
          this.getThematic();
        });
    },
    // this will show thematic areas
    getThematic: function getThematic() {
      this.openLoading();
      axios
        .post(process.env.VUE_APP_BASE_PATH + "/assessment/thematics/get", {
          thematic: this.thematicId
        }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.thematicArr = response.data;
        });
    },
    // this will show privious trainings
    getPrevious: function getPrevious() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/admin/all-training/" +
            this.trainingId +
            "/previous/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.previousTrainingArr = response.data;
        });
    },
    // this will show assessment which has been added
    showAssessment: function showAssessment() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/program-officer/training/assessment/" +
            this.trainingId +
            "/show"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.assessmentShowArr = response.data;
        });
    },
    // this will show all questions
    allQuestions: function allQuestions() {
      this.openLoading();
      axios
        .get(
          process.env.VUE_APP_BASE_PATH +
            "/admin/all-questions/assessment/get"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.allQuestionsArr = response.data;
        });
    },
    // this will show selected questions
    async moveQuestion(val, qid) {
      if (this.no_of_question != "" && this.no_of_question != 0) {
        if (this.selectedQuestionsArr.length + 1 > this.no_of_question) {
          this.$toasted.global.errorMsg("Selected questions queue is full.");
          return false;
        } else {
          let checkValue = this.selectedQuestionsArr.some(function(value) {
            return value[0].qid == qid;
          });

          if (checkValue == true) {
            this.$toasted.global.errorMsg("Question was already moved.");
          } else {
            // this.moveScrollTo();
            this.$toasted.global.successMsg("Question moved successfully!");
            this.selectedQuestionsArr.push(this.allQuestionsArr[val]);
            this.allQuestionsArr.splice(val, 1);

            this.easyPercentArr = [];
            this.mediumPercentArr = [];
            this.hardPercentArr = [];
            this.selectedQuestionsArr.forEach(async element => {
              if (element[0].qlevel == 6) {
                await this.easyPercentArr.push(element);
              }
              if (element[0].qlevel == 7) {
                await this.mediumPercentArr.push(element);
              }
              if (element[0].qlevel == 8) {
                await this.hardPercentArr.push(element);
              }
            });
            this.easyPercent = Math.floor(
              (this.easyPercentArr.length / this.no_of_question) * 100
            );
            this.mediumPercent = Math.floor(
              (this.mediumPercentArr.length / this.no_of_question) * 100
            );
            this.hardPercent = Math.floor(
              (this.hardPercentArr.length / this.no_of_question) * 100
            );
          }
        }
      } else {
        this.$toasted.global.errorMsg("Enter no of questions you want to select.");
      }
    },
    // this will remove questions from selected queue
    removeQuestion(val) {
      this.allQuestionsArr.push(this.selectedQuestionsArr[val]);
      this.selectedQuestionsArr.splice(val, 1);
      this.$toasted.global.errorMsg("Question removed from selected!");

      this.easyPercentArr = [];
      this.mediumPercentArr = [];
      this.hardPercentArr = [];
      this.selectedQuestionsArr.forEach(async element => {
        if (element[0].qlevel == 6) {
          await this.easyPercentArr.push(element);
        }
        if (element[0].qlevel == 7) {
          await this.mediumPercentArr.push(element);
        }
        if (element[0].qlevel == 8) {
          await this.hardPercentArr.push(element);
        }
      });
      this.easyPercent = Math.floor(
        (this.easyPercentArr.length / this.no_of_question) * 100
      );
      this.mediumPercent = Math.floor(
        (this.mediumPercentArr.length / this.no_of_question) * 100
      );
      this.hardPercent = Math.floor(
        (this.hardPercentArr.length / this.no_of_question) * 100
      );
    },
    // This will submit pre assessment form
    submitForm() {
      if (this.no_of_question != this.selectedQuestionsArr.length) {
        this.$toasted.global.errorMsg(
          "Please check that no. of question is equal to selected question."
        );
      } else {
        let userId = JSON.parse(localStorage.getItem("currentUser"));
        this.openLoading();
        axios
          .post(
            process.env.VUE_APP_BASE_PATH +
              "/admin/training/assessment/add",
            {
              saveSelected: this.selectedQuestionsArr,
              easy_percent: this.easyPercent,
              medium_percent: this.mediumPercent,
              hard_percent: this.hardPercent,
              training_id: this.trainingId,
              user_id: userId.id
            }
          )
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              // empty all varaibles
              this.allQuestionsArr = [];
              this.selectedQuestionsArr = [];
              this.questionForm = true;
              this.filterForm = false;
              this.thematicSelected = [];
              this.level = "";
              this.easyPercent = 0;
              this.mediumPercent = 0;
              this.hardPercent = 0;
              this.addPreassessmentForm = false;
              this.existPreassessmentForm = true;
              this.showAssessment();
              // End empty all varaibles
              this.$toasted.global.successMsg("Assessment has been created successfully.");
            } else {
              this.$toasted.global.errorMsg(
                "Error: Something went wrong while creating Assessment."
              );
            }
          });
      }
    }
  },
  // methods END now

  watch: {
    // thematicSelected(text){
    //   alert(text)
    //   this.showSelectedThematic();
    // },
    // radios1(){
    //   this.filterQuestions();
    // },
    // previoustrainingSelected() {
    //   this.filterQuestions();
    // },
    // this will check if no. of questions given in input is greater than questions selected in queue
    no_of_question() {
      if (
        this.selectedQuestionsArr.length > 0 &&
        this.no_of_question < this.selectedQuestionsArr.length
      ) {
        this.$toasted.global.errorMsg(
          "No. of questions in input, decreased from selected questions in queue."
        );
      } else if (
        this.selectedQuestionsArr.length > 0 &&
        this.no_of_question == this.selectedQuestionsArr.length
      ) {
        return true;
      } else if (this.no_of_question <= 0) {
        this.$toasted.global.errorMsg("Number of question(s) must be greater than zero.");
      } else {
        this.$toasted.global.successMsg("Now you can move questions.");
      }
    }
  }
};
</script>

<style scoped>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.b-list-group-item.opt-list-item {
  border: none !important;
}
.frm-title {
  text-align: center;
  padding: 10px;
  color: #009ad2;
  /* border-bottom: 2px solid #009ad2; */
}
.level-radios ul li {
  padding: 3px;
}
.p-2 {
  padding: 12px !important;
}
.repository-title {
  width: 142px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.filtered-title {
  width: 180px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.selected-title {
  width: 115px;
  padding: 0px 5px;
  color: rgba(7, 167, 225, 0.61);
  background-color: #fff;
  font-size: 28px;
  margin-top: -25px;
}
.crd-title {
  font-size: 20px;
}
@media print {
  .print-scr {
    display: none;
  }
}
</style>
<style >
.vs-slider {
  background-color: #c9ddff !important;
}
.con-content--item {
  padding: 0px !important;
}
</style>
